import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import usePostSetInveriteCredentials from '../../../../hooks/useApi/usePostSetInveriteCredentials';

import UpdateInveriteForm from './UpdateInveriteForm';
import UpdateInveriteReview from './UpdateInveriteReview';
import UpdateInveriteContext, { UpdateInveriteCtx } from './Dialogue/UpdateInveriteContext';
import UpdateInveriteDialogue from './Dialogue/UpdateInveriteDialogue';
import { UpdateInveriteDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useClientData } from '../../../../providers/ClientData.provider';

type FC = FunctionComponent;

const UpdateInveriteContainer: FC = () => {
  const history = useHistory();
  const [UpdateError, setUpdateError] = useState('');
  const [showUpdateErrorAlert, setShowUpdateErrorAlert] = useState(false);
  const [showUpdateSuccessAlert, setShowUpdateSuccessAlert] = useState(false);
  const [shouldUpdateInverite, setShouldUpdateInverite] = useState(false);
  const [setInveriteCredentialsResponse, setInveriteCredentials] = usePostSetInveriteCredentials({});

  const [review, setReview] = useState(false);
  const { response } = useClientData();
  const [InveriteRequest, setInveriteRequest] = useState<vp.SetInveriteCredentialsRequest>({
    InveriteAPIKey: '',
    InveriteUrl: '',
    PortalUser: response.LoginUserName,
  });

  const UpdateInverite: UpdateInveriteCtx = {
    showUpdateSuccessAlert,
    showUpdateErrorAlert,
    UpdateError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<UpdateInveriteDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: UpdateInveriteDialogueHandler = {
        update: {
          success: {
            default: () => {
              setShowUpdateSuccessAlert(false);
              history.push('/integrations/Inverite');
            },
          },
          error: {
            default: () => {
              setShowUpdateErrorAlert(false);
              setUpdateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onReview: (values: vp.SetInveriteCredentialsRequest) => {
      setReview(true);
      setInveriteRequest(values);
    },
    onUpdate: (values: vp.SetInveriteCredentialsRequest) => {
      setShouldUpdateInverite(true);

      setInveriteCredentials(values);
    },
    onBack: () => {
      setReview(false);
    },
  };

  useEffect(() => {
    if (shouldUpdateInverite) {
      setShouldUpdateInverite(false);

      if (setInveriteCredentialsResponse?.Success === true) {
        setShowUpdateSuccessAlert(true);
      } else {
        setUpdateError(setInveriteCredentialsResponse?.ErrorMessage || '');
        setShowUpdateErrorAlert(true);
      }
    }
  }, [setInveriteCredentialsResponse]);

  return (
    <UpdateInveriteContext.Provider value={UpdateInverite}>
      {!review && <UpdateInveriteForm defaultValues={InveriteRequest} onSubmit={handlers.onReview} />}
      {review && (
        <UpdateInveriteReview defaultValues={InveriteRequest} onSubmit={handlers.onUpdate} onBack={handlers.onBack} />
      )}
      <UpdateInveriteDialogue handleDialogue={handlers.handleDialogue} />
    </UpdateInveriteContext.Provider>
  );
};

export default UpdateInveriteContainer;
